import { AfterViewInit, Component } from '@angular/core';

@Component({
    selector: '[app-service-checkup]',
    templateUrl: './service-checkup.component.html',
    styleUrls: ['./service-checkup.component.css'],
    standalone: false
})
export class ServiceCheckupsComponent implements AfterViewInit {
  ngAfterViewInit() {
    window.dispatchEvent(new CustomEvent("ComponentLoad", { detail: "ServiceCheckups" }));
  }
}
